import { actionTypes } from '../../types';

// Action request
export const getMyBrandBusinessDetailForAgency = (payload, callback) => ({
    type: actionTypes.GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_REQUEST,
    payload,
    callback
});

// Action success
export const getMyBrandBusinessDetailForAgencySuccess = (payload) => ({
    type: actionTypes.GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_SUCCESS,
    payload,
});

// Action failure
export const getMyBrandBusinessDetailForAgencyFailure = (payload) => ({
    type: actionTypes.GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_FAILURE,
    payload,
});

// Action reset status
export const getMyBrandBusinessDetailForAgencyReset = () => ({
    type: actionTypes.GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET,
});

// Action reset all reducer
export const getMyBrandBusinessDetailForAgencyResetAll = () => ({
    type: actionTypes.GET_MY_BRAND_BUSINESS_DETAIL_FOR_AGENCY_RESET_ALL,
});
